var _circle, _circle2, _circle3, _rect, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile40 = function SvgProfile40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#D1B896"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Profile_40_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Profile_40_svg__a)"
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 31.5,
    cy: 3.5,
    r: 12.5,
    stroke: "#000",
    strokeWidth: 6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: -4,
    y: 25,
    width: 27.5,
    height: 30,
    rx: 2,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.876 22.361c4.085 0 7.396-3.327 7.396-7.43 0-4.104-3.311-7.431-7.396-7.431-4.084 0-7.396 3.327-7.396 7.43 0 4.104 3.312 7.431 7.396 7.431Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.876 21.361c4.085 0 7.396-3.327 7.396-7.43 0-4.104-3.311-7.431-7.396-7.431-4.084 0-7.396 3.327-7.396 7.43 0 4.104 3.312 7.431 7.396 7.431Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.681 25.562a13.851 13.851 0 0 0-8.774 4.715 14.096 14.096 0 0 0-3.405 9.425v35.757c0 1.204.474 2.36 1.318 3.21A4.479 4.479 0 0 0 13 80a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212v-4.541c0-1.204.474-2.36 1.318-3.211a4.479 4.479 0 0 1 3.182-1.33c1.193 0 2.338.478 3.182 1.33a4.563 4.563 0 0 1 1.318 3.21v4.543c0 1.204.474 2.36 1.317 3.21A4.479 4.479 0 0 0 31 80a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212V39.127c-.004-1.9-.4-3.78-1.166-5.516a13.65 13.65 0 0 0-3.275-4.57 13.5 13.5 0 0 0-4.825-2.844 13.411 13.411 0 0 0-5.553-.634Z",
    fill: "#000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.681 23.562a13.851 13.851 0 0 0-8.774 4.715 14.096 14.096 0 0 0-3.405 9.425v35.757c0 1.204.474 2.36 1.318 3.21A4.479 4.479 0 0 0 11 78a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212v-4.541c0-1.204.474-2.36 1.318-3.211a4.479 4.479 0 0 1 3.182-1.33c1.193 0 2.338.478 3.182 1.33a4.563 4.563 0 0 1 1.318 3.21v4.543c0 1.204.474 2.36 1.317 3.21A4.479 4.479 0 0 0 29 78a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212V37.127c-.004-1.9-.4-3.78-1.166-5.516a13.65 13.65 0 0 0-3.275-4.57 13.5 13.5 0 0 0-4.825-2.844 13.411 13.411 0 0 0-5.553-.634Z",
    fill: "#EDE3D5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Profile_40_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 23,
    width: 28,
    height: 55
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.681 23.562a13.851 13.851 0 0 0-8.774 4.715 14.096 14.096 0 0 0-3.405 9.425v35.757c0 1.204.474 2.36 1.318 3.21A4.479 4.479 0 0 0 11 78a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212v-4.541c0-1.204.474-2.36 1.318-3.211a4.479 4.479 0 0 1 3.182-1.33c1.193 0 2.338.478 3.182 1.33a4.563 4.563 0 0 1 1.318 3.21v4.543c0 1.204.474 2.36 1.317 3.21A4.479 4.479 0 0 0 29 78a4.479 4.479 0 0 0 3.182-1.33 4.563 4.563 0 0 0 1.318-3.212V37.127c-.004-1.9-.4-3.78-1.166-5.516a13.65 13.65 0 0 0-3.275-4.57 13.5 13.5 0 0 0-4.825-2.844 13.411 13.411 0 0 0-5.553-.634Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Profile_40_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.5 23.245a9.14 9.14 0 0 0 3.237 3.123A8.632 8.632 0 0 0 20 27.5a8.633 8.633 0 0 0 4.263-1.132 9.14 9.14 0 0 0 3.237-3.123 10.676 10.676 0 0 0-3.95-2.597 10.27 10.27 0 0 0-4.628-.595c-2.432.238-4.706 1.368-6.422 3.192Z",
    fill: "#000"
  })))));
};
export default SvgProfile40;